import { SignalDispatcher } from 'ste-signals';

export const customerUserEvents = {
  customerUserRemoved: new SignalDispatcher(),
  customerUserAdded: new SignalDispatcher(),
  onCustomerUserSetMain: new SignalDispatcher(),
  onCustomerUserCustomTypeChanged: new SignalDispatcher(),
};
